import messages from './cmsPreview.json' with { type: 'json' };

export const cmsPreviewFi: Readonly<typeof messages> = messages;
